module.exports = __webpack_public_path__ + "media/images/favicons/mstile-150x150-f3c7842e8365bfffb28485961d2b910e.png";